<template>
  <Teleport to="body">
    <!-- Backdrop -->
    <div class="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
         @click.self="$emit('close')">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="$emit('close')" />

      <!-- Sheet / Dialog -->
      <div class="relative w-full sm:max-w-md bg-white dark:bg-slate-900
                  rounded-t-3xl sm:rounded-2xl shadow-xl
                  max-h-[92dvh] overflow-y-auto
                  animate-slide-up sm:animate-none">

        <!-- Handle (mobile) -->
        <div class="sm:hidden flex justify-center pt-3 pb-1">
          <div class="w-10 h-1 rounded-full bg-slate-200 dark:bg-slate-700" />
        </div>

        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 border-b border-slate-100 dark:border-slate-800">
          <h3 class="text-base font-bold text-slate-800 dark:text-white">
            <slot name="title" />
          </h3>
          <button @click="$emit('close')"
            class="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400
                   hover:bg-slate-100 dark:hover:bg-slate-800 transition">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="px-5 py-5">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
defineEmits(['close'])
</script>

<style>
@keyframes slide-up {
  from { transform: translateY(100%); }
  to   { transform: translateY(0); }
}
.animate-slide-up {
  animation: slide-up 0.25s cubic-bezier(0.32, 0.72, 0, 1);
}
</style>
